<div class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>

      <ng-container *ngIf="state === 'ok'">
        <h1>Register to join {{ orgName }}</h1>
        <p>You have been invited to join {{ orgName ?? 'an organization' }}</p>

        <app-log-in-google-button></app-log-in-google-button>

        <form [formGroup]="form" (ngSubmit)="submit(form.value)">
          <fieldset [disabled]="waiting">
            <div class="form-group">
              <mat-form-field
                class="simple-form-field-100"
                [floatLabel]="'always'"
              >
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="text"
                  name="email"
                  formControlName="email"
                  autocomplete="email"
                  required
                />
                <mat-error>Not a valid email</mat-error>
              </mat-form-field>

              <mat-form-field
                class="simple-form-field-100"
                [floatLabel]="'always'"
              >
                <mat-label>Password</mat-label>
                <input
                  matInput
                  type="password"
                  name="password"
                  formControlName="password"
                  autocomplete="new-password"
                  required
                />
                <mat-progress-bar
                  [color]="updatePasswordProgressColor(passwordGuessesLog10)"
                  mode="determinate"
                  value="{{ passwordProgressBarValue.toString() }}"
                >
                </mat-progress-bar>
                <mat-error>{{ passwordErrorMessage }}</mat-error>
              </mat-form-field>

              <div class="button-right-container">
                <div></div>
                <div>
                  <div class="spinner-container" *ngIf="waiting">
                    <mat-spinner diameter="24"></mat-spinner>
                  </div>
                  <button
                    mat-raised-button
                    color="primary"
                    [disabled]="waiting || disableSubmit"
                    type="submit"
                    value="submit"
                  >
                    Register
                  </button>
                </div>
              </div>
              <span *ngIf="formErrorMessage" class="text-error-color">
                {{ formErrorMessage }}
              </span>

              <p>
                By registering, you agree to our
                <a [href]="this.homepageLinks.privacy" class="text-link"
                  >Privacy Policy</a
                >
                and our
                <a [href]="this.homepageLinks.terms" class="text-link"
                  >Terms and Conditions.</a
                >
                This site is protected by reCAPTCHA.
              </p>
            </div>
          </fieldset>
        </form>
      </ng-container>

      <ng-container *ngIf="state === 'unknownError'">
        <h1>Error</h1>
        <p>There was an unknown error.</p>
        <p>If you continue to have this problem, please contact support.</p>
      </ng-container>

      <ng-container *ngIf="state === 'noConnection'">
        <h1>Connection error</h1>
        <p>
          We're having trouble connecting to the server. Check your internet
          connection and reload to retry.
        </p>
      </ng-container>

      <ng-container *ngIf="state === 'inviteExpired'">
        <h1>Invite expired</h1>
        <p>
          This invite has expired. You should contact your administrator to gain
          access.
        </p>
        <a routerLink="/login">
          <button mat-raised-button color="primary">
            Click here to log in
          </button>
        </a>
      </ng-container>

      <ng-container *ngIf="state === 'linkBroken'">
        <h1>Link broken</h1>
        <p>
          There was a problem with the link. Try copying the link again, or
          requesting a new invite from your organization's administrator.
        </p>
        <p>You may have already created an account. If so, log in below:</p>
        <a routerLink="/login">
          <button mat-raised-button color="primary">
            Click here to log in
          </button>
        </a>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
